var render = function render(){var _vm=this,_c=_vm._self._c;return _c('standard-container',{attrs:{"menu-id":"promozioni"}},[_c('v-alert',{attrs:{"outlined":"","text":"","type":"info"}},[_c('div',{staticClass:"title"},[_vm._v("Lavori in corso...")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }